// extracted by mini-css-extract-plugin
export default {"custom_svg_button":"collect-button_custom_svg_button__JjFuW"};